import React from "react";
import FrontendLayout from "../layouts/FrontendLayout";
import { SignInPanel } from "../containers"
import { useDocumentTitle } from "../hooks";

const SignInPage = () => {
  useDocumentTitle("ログイン - 点検王");
  
  return (
    <FrontendLayout>
      <div className="flex flex-col">
        <div className="flex-1">
          <SignInPanel />
        </div>
      </div>
    </FrontendLayout>
  );
};

export default SignInPage;
